<template>
  <main class="main inside-page cabinet-page">
    <div class="section topics-section">
      <div class="wrapper">
        <div class="left">
          <div class="left-wrapper">
            <img class="img" :src="room.image_url" />
            <div class="title">
              {{ room.title }}
            </div>
            <button class="button colored" @click.prevent="newTopic">
              <img src="@/images/add.svg" />
              <span>{{ $t("Create topic") }}</span>
            </button>
            <router-link to="/rooms" class="button bordered-white">
              <span>{{ $t("Leave room") }}</span>
            </router-link>
          </div>
        </div>
        <div class="right">
          <div class="title title-16">{{ $t("Active chats") }}:</div>
          <div class="list">
            <template v-for="(item, i) in topics">
              <a
                :key="i"
                class="item"
                v-if="item.bot_name && item.title"
                @click.prevent="selectTopic(item)"
              >
                <div class="desc small purple">
                  <b>{{ item.bot_name }}</b>
                </div>
                <div class="desc">{{ item.title }}</div>
              </a>
            </template>
          </div>
          <div class="no-topics" v-if="topics.length == 0">
            <div class="desc">
              <span>{{ $t("No topics") }}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </main>
</template>
<script>
import { mapActions, mapGetters, mapMutations } from "vuex";
import axios from "@/axios";

export default {
  name: "Topics",
  props: [],
  components: {},
  data: function () {
    return {};
  },
  async mounted() {
    if (!this.rooms.length) {
      await this.getRooms();
    }

    await this.getTopics(this.$route.params.name);
  },
  methods: {
    ...mapActions("rooms", ["getRooms"]),
    ...mapActions("topics", ["startRandomTopic", "getTopics"]),
    async selectTopic({ id, is_chat_participant, slug }) {
      if (is_chat_participant) {
        this.SET_TOPIC(id);
        await this.$router.push({
          name: "Chat",
          params: { name: this.$route.params.name, slug },
        });
      } else {
        // axios.post("topics/" + id + "/accept-terms");
        await this.acceptTerms(id);
        await this.joinChat({ roomSlug: this.$route.params.name, id, slug });
      }
    },
    newTopic() {
      const self = this;

      axios
        .get("topics/allowed-new")
        .then(({ data }) => {
          if (data.status === "OK") {
            self.$router.push({ name: "CreateTopic" });
          }
        })
        .catch(({ response }) => {
          if (response.status === 403 && response.data.message) {
            self.showNotification({ text: response.data.message });
          }
        });
    },
    ...mapMutations("topics", ["SET_TOPIC"]),
    ...mapActions("topics", ["joinChat", "acceptTerms"]),
    ...mapActions("app", ["showNotification"]),
  },
  computed: {
    ...mapGetters("rooms", ["rooms"]),
    ...mapGetters("topics", ["topics", "room"]),
  },
};
</script>
